export default __webpack_public_path__ + "assets/ico_feed_like_filled-8fe4062d.svg";